/* PagingWorkTargetRelatedDevicesFeed.js */

const PagingFeed = require("../../../../../../lib/PagingFeed");

class PagingWorkTargetRelatedDevicesFeed extends PagingFeed {
    _getFeed() {
        return this._EntityDef.startRelatedDevicesFeed(undefined, undefined, this._sort, { skip: 0, limit: this._pageSize * 2 });
    }
}

module.exports = PagingWorkTargetRelatedDevicesFeed;
